exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hotzone[data-v-22bbb3ea] {\n  max-width: 500px;\n  margin-bottom: 10px;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);\n}\n.uploader-setting[data-v-22bbb3ea] {\n  padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-22bbb3ea","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/pc/custompage/components/plugins/imgHotzone/style.vue
// module id = 1289
// module chunks = 0